import { useEffect, useRef, useState } from 'react';

// Hedef değere requestAnimationFrame ile yumuşak geçiş (count-up).
// Değer değiştiğinde bulunduğu yerden yeni hedefe animasyonla ilerler.
export default function useCountUp(target, { duration = 900, decimals = 0 } = {}) {
  const [display, setDisplay] = useState(target || 0);
  const fromRef = useRef(target || 0);
  const rafRef = useRef(null);
  const startRef = useRef(0);

  useEffect(() => {
    const prefersReduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    const from = fromRef.current;
    const to = Number(target) || 0;
    if (prefersReduced || from === to) {
      fromRef.current = to;
      setDisplay(to);
      return undefined;
    }

    startRef.current = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - startRef.current) / duration);
      // easeOutCubic
      const eased = 1 - Math.pow(1 - p, 3);
      const val = from + (to - from) * eased;
      setDisplay(val);
      if (p < 1) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        fromRef.current = to;
        setDisplay(to);
      }
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [target, duration]);

  const factor = Math.pow(10, decimals);
  return Math.round(display * factor) / factor;
}
